import { render, staticRenderFns } from "./GapLabTestEditor.vue?vue&type=template&id=086970c3&"
import script from "./GapLabTestEditor.vue?vue&type=script&lang=ts&"
export * from "./GapLabTestEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports